import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PresentUsersLiveDashboardViewComponent } from './views/present-users-live-dashboard-view/present-users-live-dashboard-view.component';
import { PresentUsersFiltersComponent } from './containers/present-users-filters/present-users-filters.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from '@shared/shared.module';
import { PresentUsersTableComponent } from './containers/present-users-table/present-users-table.component';
import { PlatformContextModule } from '@/app/platform/platform-context/platform.context.module';

@NgModule({
  declarations: [
    PresentUsersLiveDashboardViewComponent,
    PresentUsersFiltersComponent,
    PresentUsersTableComponent
  ],
  exports: [PresentUsersLiveDashboardViewComponent],
  imports: [CommonModule, NgSelectModule, SharedModule, PlatformContextModule]
})
export class PresentUsersManagementBlockModule {}
